import { useEffect, useState } from "react";

import { Badge, Button, Card, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Typography } from "@mui/material";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { AiOutlineOrderedList, AiOutlineFileText } from "react-icons/ai";

import moment from "moment";

import { Layout } from "../../../components/Layout";

import { TablePaginationActions } from "../../../helpers/TablePaginationActions";

import { usePages } from "../../../hooks/usePages";

import { TableTheadStyle, TablePaddingStyle } from "../../../styles/TableStyle";

import { DialogDocumento } from "../../../dialogs/DialogDocumento";

import { BuscarListaEstrados } from "../../../connections/tribunal/ListaEstradosConnection";

import { ListaEstradosResultado, NotificacionDetalleResponse } from "../../../interfaces/tribunal/ListaEstradosInterface";

export const ConsultarListaEstradosPage = () => {

    const [rows, setRows] = useState<ListaEstradosResultado[]>( [] );
    const [recordsCount, setRecordsCount] = useState( 0 );
    const [loading, setLoading] = useState( false );
    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [fechaInicio, setFechaInicio] = useState<moment.Moment | null>( moment() );
    const [fechaFin, setFechaFin] = useState<moment.Moment | null>( moment() );

    const [page, setPage] = useState( 0 );
    const [rowsPerPage, setRowsPerPage] = useState( 10 );

    const [openEstrados, setOpenEstrados] = useState( false );
    const [estrados, setEstrados] = useState<NotificacionDetalleResponse[]>( [] );

    const [documento, setDocumento] = useState( '' );
    const [openDocumento, setOpenDocumento] = useState( false );

    const { page: pageEstrados, rowsPerPage: rowsPerPageEstrados, handleChangePage: handleChangePageEstrados, handleChangeRowsPerPage: handleChangeRowsPerPageEstrados } = usePages( 5 );

    const handleBuscar = () => {

        setFiltroAplicado( true );
        setPage( 0 );

    };

    const handleLimpiar = () => {

        setFiltroAplicado( false );
        setFechaInicio( moment() );
        setFechaFin( moment() );
        setRows( [] );
        setRecordsCount( 0 );
        setPage( 0 );

    };

    useEffect(() => {

        if ( !filtroAplicado || !fechaInicio || !fechaFin ) return;

        setLoading( true );
        setRows( [] );

        BuscarListaEstrados({

            fechaInicio: fechaInicio.format( 'YYYY-MM-DD' ),
            fechaFin: fechaFin.format( 'YYYY-MM-DD' ),
            page,
            rowsPerPage

        }).then(response => {

            setTimeout(() => {

                setRows( response.records ?? [] );
                setRecordsCount( response.recordsCount ?? 0 );
                setLoading( false );

            }, 700);

        });

    }, [filtroAplicado, page, rowsPerPage, fechaInicio, fechaFin]);

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Lista de estrados' }, { text: 'Consultar lista de estrados' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={ <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography> }
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ xs: 12, md: 5 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment }>

                                        <DatePicker
                                            label="Fecha de inicio"
                                            sx={{ width: '100%' }}
                                            value={ fechaInicio }
                                            maxDate={ moment() }
                                            onChange={ (val) => setFechaInicio( val ) }
                                        />

                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ xs: 12, md: 5 }}>

                                    <LocalizationProvider dateAdapter={ AdapterMoment }>

                                        <DatePicker
                                            label="Fecha de finalización"
                                            sx={{ width: '100%' }}
                                            value={ fechaFin }
                                            maxDate={ moment() }
                                            onChange={ (val) => setFechaFin( val ) }
                                        />

                                    </LocalizationProvider>

                                </Grid>

                                <Grid size={{ xs: 12, md: 2 }}>

                                    <Button
                                        fullWidth
                                        variant="contained"
                                        loading={ loading }
                                        disabled={ !fechaInicio || !fechaFin }
                                        onClick={ filtroAplicado ? handleLimpiar : handleBuscar }
                                    >
                                        { filtroAplicado ? 'Limpiar' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Fecha</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '30%', fontWeight: 'bold' }}>Usuario generó</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Ver acuerdos</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Ver lista de estrados</TableCell>                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map(({ idListaEstrados, fechaGeneracion, usuarioGenero, numeroNotificaciones, notificaciones, documentoListaEstradosFirmada }, index) => (

                                        <TableRow key={ index } >

                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Typography variant="subtitle1">
                                                    <strong>{ 'GLES-' + idListaEstrados }</strong>
                                                </Typography>
                                            </TableCell>

                                            <TableCell>

                                                <Typography variant='subtitle1'>
                                                    { moment( fechaGeneracion ).format( 'DD-MM-YYYY' ) }
                                                </Typography>

                                                <Typography variant='caption' color='text.secondary'>
                                                    { moment( fechaGeneracion ).format( 'hh:mm a' ) }
                                                </Typography>

                                            </TableCell>

                                            <TableCell> <Typography variant='subtitle1' fontSize={ 14 }>{ usuarioGenero } </Typography> </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Tooltip title='Visualizar acuerdos'>

                                                    <IconButton color="primary" onClick={ () => { setEstrados( notificaciones ); setOpenEstrados( true ); } }>

                                                        <Badge
                                                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                                                            badgeContent={ <Typography variant="subtitle2">{ numeroNotificaciones }</Typography> }
                                                            color="secondary"
                                                        >
                                                            <AiOutlineOrderedList fontSize={ 28 } />
                                                        </Badge>

                                                    </IconButton>

                                                </Tooltip>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Tooltip title='Visualizar lista de estrados'>
                                                    <IconButton color="primary" onClick={ () => { setDocumento( documentoListaEstradosFirmada ); setOpenDocumento( true ); } }>
                                                        <AiOutlineFileText fontSize={ 28 } />
                                                    </IconButton>
                                                </Tooltip>

                                            </TableCell>

                                            <TableCell>

                                                <Chip
                                                    variant="filled"
                                                    color="primary"
                                                    sx={{ width: '100%', py: 3 }}
                                                    label={
                                                        <>
                                                            <Typography variant="subtitle2">Publicada</Typography>
                                                        </>
                                                    }
                                                />

                                            </TableCell>

                                        </TableRow>

                                    ))
                                }

                                {
                                    rows.length === 0 &&
                                    <TableRow>
                                        <TableCell colSpan={ 6 } align="center">
                                            <Typography variant="caption" color='secondary'>
                                                { loading ? 'Buscando...' : 'No se encontraron registros' }
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordsCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        rowsPerPageOptions={ [5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                        colSpan={ 8 }
                                        count={ recordsCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ (_, newPage) => setPage( newPage ) }
                                        onRowsPerPageChange={ (e) => { setRowsPerPage( parseInt( e.target.value ) ); setPage( 0 ); } }
                                        ActionsComponent={ TablePaginationActions }
                                        labelRowsPerPage={ 'Filas por página:' }
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count;
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDocumento }
                handleCloseDialog={ () => setOpenDocumento( false ) }
            />

            <Dialog
                maxWidth="lg"
                fullWidth={ true }
                open={ openEstrados }
                onClose={ () => {} }
            >

                <DialogTitle>
                    Acuerdo(s)
                </DialogTitle>

                <DialogContent>

                    <Grid container spacing={ 3 } >

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TableContainer sx={{ borderRadius: 3 }}>

                                <Table>

                                    <TableHead sx={{ ...TableTheadStyle }}>

                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Fecha</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '12%', fontWeight: 'bold' }}>Referencia</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Tipo de juicio</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '12%', fontWeight: 'bold' }}>Tipo de acuerdo</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '17%', fontWeight: 'bold' }}>Actor(es)</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '16%', fontWeight: 'bold' }}>Demandado(s)</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Se notifica a</TableCell>
                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', fontWeight: 'bold' }}></TableCell>

                                        </TableRow>

                                    </TableHead>

                                    <TableBody>

                                        {
                                            (rowsPerPageEstrados > 0
                                                ? estrados.slice( pageEstrados * rowsPerPageEstrados, pageEstrados * rowsPerPageEstrados + rowsPerPageEstrados )
                                                : estrados
                                            ).map(({ fechaAcuerdo, referencia, otraReferencia, tipoJuicio, tipoParte, tipoAcuerdo, subTipoAcuerdo, actores, demandados, documentoAcuerdoFirmado }, index) => (

                                                <TableRow key={ index } >

                                                    <TableCell>

                                                        <Typography variant='subtitle1'>
                                                            { moment( fechaAcuerdo, 'DD-MM-YYYY HH:mm' ).format( 'DD-MM-YYYY' ) }
                                                        </Typography>

                                                        <Typography variant='caption' color='text.secondary'>
                                                            { moment( fechaAcuerdo, 'DD-MM-YYYY HH:mm' ).format( 'hh:mm a' ) }
                                                        </Typography>

                                                    </TableCell>

                                                    <TableCell>
                                                        <Typography variant="subtitle1">
                                                            <strong>{ referencia }</strong>
                                                        </Typography>
                                                        <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 12 }>F. { otraReferencia }</Typography>
                                                    </TableCell>

                                                    <TableCell> { tipoJuicio } </TableCell>

                                                    <TableCell>
                                                        {
                                                            subTipoAcuerdo
                                                                ?
                                                                <>
                                                                    <Typography variant="subtitle1" fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>
                                                                    <Typography variant="subtitle2" fontWeight={ 'normal' } fontSize={ 12 }>( { subTipoAcuerdo } )</Typography>
                                                                </>
                                                                :
                                                                <Typography variant="subtitle1" fontWeight={ 'bold' }>{ tipoAcuerdo }</Typography>
                                                        }
                                                    </TableCell>

                                                    <TableCell>{ actores?.join( ', ' ) }</TableCell>

                                                    <TableCell>{ demandados?.join( ', ' ) }</TableCell>

                                                    <TableCell>{ 'SE NOTIFICA A LA PARTE ' + ( tipoParte?.toUpperCase() ?? '' ) }</TableCell>

                                                    <TableCell sx={{ textAlign: 'end' }}>

                                                        <Tooltip title='Visualizar acuerdo'>
                                                            <IconButton color="primary" onClick={ () => { setDocumento( documentoAcuerdoFirmado ); setOpenDocumento( true ); } }>
                                                                <AiOutlineFileText fontSize={ 28 } />
                                                            </IconButton>
                                                        </Tooltip>

                                                    </TableCell>

                                                </TableRow>

                                            ))
                                        }

                                        {
                                            estrados.length === 0
                                            &&
                                            <TableRow>
                                                <TableCell
                                                    colSpan={ 8 }
                                                    align="center"
                                                >
                                                    <Typography variant="caption" color='secondary'> No se encontraron registros </Typography>
                                                </TableCell>
                                            </TableRow>
                                        }

                                    </TableBody>

                                    <TableFooter>

                                        <TableRow>

                                            <TableCell colSpan={ 2 }>
                                                <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { estrados.length } </Typography>
                                            </TableCell>

                                            <TablePagination
                                                rowsPerPageOptions={ [5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                                colSpan={ 8 }
                                                count={ estrados.length }
                                                rowsPerPage={ rowsPerPageEstrados }
                                                page={ pageEstrados }
                                                onPageChange={ handleChangePageEstrados }
                                                onRowsPerPageChange={ handleChangeRowsPerPageEstrados }
                                                ActionsComponent={ TablePaginationActions }
                                                labelRowsPerPage={ 'Filas por página:' }
                                                labelDisplayedRows={
                                                    ({ from, to, count }) => {
                                                        return '' + from + '-' + to + ' de ' + count;
                                                    }
                                                }
                                            />

                                        </TableRow>

                                    </TableFooter>

                                </Table>

                            </TableContainer>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button color='secondary' onClick={ () => setOpenEstrados( false ) }>Cerrar</Button>
                </DialogActions>

            </Dialog>

        </Layout>
    )
}
